export const SERVICE_OPTIONS = [
  { value: 'DIGITAL_TRANSFORMATION', label: 'Digital Transformation' },
  { value: 'COMPUTER_VISION', label: 'Computer Vision Intelligence' },
  { value: 'INDUSTRY_4_0', label: 'Industry 4.0 Implementation' },
  { value: 'CLOUD_MIGRATION', label: 'Cloud Consultancy & Migration' },
  { value: 'AUTOMATION', label: 'Automation Solutions' },
  { value: 'TECHNOLOGY_INFRASTRUCTURE', label: 'Technology Infrastructure Solutions' },
  { value: 'AWS_PARTNER', label: 'AWS Partner Services' },
  { value: 'ONIFIED_AI', label: 'Onified.ai Platform' },
  { value: 'CAREERS', label: 'Careers' },
  { value: 'OTHER', label: 'Other' },
];

export const DEFAULT_SERVICE = 'OTHER';

export const getServiceLabel = (value) => {
  const match = SERVICE_OPTIONS.find((opt) => opt.value === value);
  return match ? match.label : value;
};
